// generate=ts:EventTypeEnums
/** Valid queue event types */
export var QueueEventType;
(function (QueueEventType) {
    /** Match all queue event types */
    QueueEventType["all"] = "queue.*";
    /** Notification that an agent was assigned to a queue */
    QueueEventType["agentAdded"] = "queue.agentAdded";
    /** Notification that an agent was removed from a queue */
    QueueEventType["agentRemoved"] = "queue.agentRemoved";
    /** Notification that a new queue was created */
    QueueEventType["created"] = "queue.created";
    /** Notification that a queue was deleted */
    QueueEventType["deleted"] = "queue.deleted";
    /** Notification that a session has been delivered to an agent */
    QueueEventType["sessionDelivered"] = "queue.sessionDelivered";
    /** Notification that a session has joined the queue */
    QueueEventType["sessionJoined"] = "queue.sessionJoined";
    /** Notification that a session has left the queue without being delivered to an agent */
    QueueEventType["sessionLeft"] = "queue.sessionLeft";
    /** Synchronizing notification about current queue statistics and agents */
    QueueEventType["status"] = "queue.status";
})(QueueEventType || (QueueEventType = {}));
//# sourceMappingURL=queue-events.js.map